import React from "react";
import { Tooltip, Button, message } from "antd";
import { WhatsAppOutlined } from "@ant-design/icons";

const PropertyWhatsAppButton = () => {
  return (
    <Tooltip title="WhatsApp" placement="top">
      <a
        href="https://wa.me/045771575"
        target="_blank"
        rel="noopener noreferrer"
      >
        <Button
          type="default"
          icon={<WhatsAppOutlined />}
          size="middle"
          style={{
            backgroundColor: "#fff",
            borderColor: "#FDA94F",
            color: "#FDA94F",
            // borderRadius: 12,
            fontWeight: 500,
            width: "100px"
          }}
        >
          Whatsapp
        </Button>
      </a>
    </Tooltip>
  );
};

export default PropertyWhatsAppButton;
